var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgScissorClosed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1733_80381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4004 18.8641L10.6853 0.8641",
    stroke: "#161616",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4003 18.864L14.0958 1.10775",
    stroke: "#161616",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.4004,
    cy: 20.1078,
    r: 3.25,
    transform: "rotate(90 15.4004 20.1078)",
    stroke: "#161616",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.40039,
    cy: 20.1078,
    r: 3.25,
    transform: "rotate(90 8.40039 20.1078)",
    stroke: "#161616",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1733_80381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgScissorClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scissor_closed.6a6be37ffa24dc8b824883eeaadb3470.svg";